import { breakpoints } from '@eversports/design-tokens/breakpoints'
import { match } from 'css-mediaquery'

const customMediaQueryMatcher = (deviceType: string) => (query: string) => ({
  matches: match(query, {
    width: deviceType === 'mobile' ? `${breakpoints.xs}px` : `${breakpoints.lg}px`,
  }),
})

export default customMediaQueryMatcher
